module.exports = __webpack_public_path__ + "static/media/done.b378c4f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/done.svg
// module id = 2849
// module chunks = 0